import { BadgeCheck, Share, Smartphone } from "lucide-react";
import { useInstallPrompt } from "@/features/pwa/useInstallPrompt";

const COPY = {
  ios: "In Safari, tap the Share button, then “Add to Home Screen”.",
  manual: "Open your browser menu and choose “Install app” or “Add to Home Screen”. Some browsers don't support installing.",
};

export function InstallPanel() {
  const { mode, install } = useInstallPrompt();
  if (mode === "installed") {
    return <p data-testid="install-state" data-state="installed" className="flex items-center gap-2 text-sm"><BadgeCheck className="h-4 w-4 text-emerald-700" /> Installed on this device.</p>;
  }
  if (mode === "prompt") {
    return (
      <button type="button" onClick={install} data-testid="install-button" data-state="prompt" className="mw-btn mw-btn-primary">
        <Smartphone className="h-4 w-4" /> Add to Home Screen
      </button>
    );
  }
  return (
    <p data-testid="install-state" data-state={mode} className="flex items-start gap-2 text-sm text-muted-foreground">
      <Share className="mt-0.5 h-4 w-4 shrink-0" /> {COPY[mode]}
    </p>
  );
}
